import styled from 'styled-components';
import logo from '../assets/logo/RJ_192.png';
import { RJGrueso } from '../assets/icons';
import { getFontSize } from '../utils/getFont';

const Container = styled.div`
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 80px;
  align-items: center;
  padding: 1rem 2rem;
  color: var(--background-alt);
  background-color: var(--text-muted);
  overflow: hidden;

  svg {
    height: 100%;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: left;
  width: 100%;
  height: 90%;

  ${getFontSize(0)}

  a {
    color: inherit;
    text-decoration: underline;
  }
`;

export const Footer = () => {
  return (
    <Container>
      <RJGrueso color="#f7e8c7" size={80} />
      <Content>
        <div>
          Ilustraciones de{' '}
          <a href="https://www.instagram.com/inessierrapra/" target="_blank" rel="noopener noreferrer">
            <strong>Inés Sierra</strong>
          </a>
        </div>
        <div>
          Diseño web de{' '}
          <a href="https://www.instagram.com/juangutierreza/" target="_blank" rel="noopener noreferrer">
            Juan Gutiérrez
          </a>
        </div>
      </Content>
    </Container>
  );
};
